import NavigationBar from './NavigationBar';
import React, { useState } from 'react';
import './TranslatedApp.css';

function TranslatedApp({ children }) {
  const [updatingTranslations] = useState(false);

  return (
    <div>
      <NavigationBar />
      <div
        id="container"
        className={`container ${updatingTranslations ? 'updating-translations' : ''}`}
      >
        {children}
      </div>
    </div>
  );
}

export default TranslatedApp;